var map = {
	"./de.json": "B4A8",
	"./fr.json": "FiWC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1pse";


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*\.json$
// module id = 1pse
// module chunks = 1